import DeviceDetector from "device-detector-js";

const deviceDetector = new DeviceDetector();
const device = deviceDetector.parse(navigator.userAgent);

export default device;
